export default __webpack_public_path__ + "static/media/photo-charte01.6442157f.png";